<div class="dialogue-content">
    <a class="close-btn" mat-dialog-close (click)="close()"><i class="ri-close-fill"></i></a>
    <mat-dialog-content>
        <div class="text-center">
            <form [formGroup]="verificationForm" novalidate>
                <img src="../../../../assets/images/mail-icon.svg" class="mb-4 m-auto d-table" />
                <h5 class="text-center text-primary">Change Password Authentication</h5>
                <p class="fs-6 mb-3">The change password authentication code has been successfully sent to your
                    registered email.
                    <a href="#" class="text-white text-decoration-underline">{{ emailId }}</a>
                <div
                    class="form-group mb-3 d-flex align-items-center justify-content-center gap-4 text-center otp-bar flex-nowrap whitespace-nowrap">
                    <ng-otp-input (onInputChange)="onOtpChange($event)" #ngOtpInput [config]="config"></ng-otp-input>
                </div>
                <div class="expire-info">
                    <ng-template [ngIf]="counter != 0" [ngIfElse]="TimeExpired">
                        <p>Timer expire in <span>{{minutes}} : {{seconds}}</span></p>
                    </ng-template>
                    <ng-template #TimeExpired>
                        <p><span class="text-danger">Time Expired</span></p>
                    </ng-template>
                </div>
                <button matButton="filled" type="button" class="w-75 btn-primary mb-3" [disabled]="submitted == true"
                    (click)="verifyCode()">Verify</button>
                <p class="fs-6">
                    Don't receive the code?
                    <a (click)="!isResendDisabled && ResendOTP()"
                        [ngClass]="{'disabled-link': isResendDisabled}">Resend Code</a>
                </p>
            </form>
        </div>
    </mat-dialog-content>
</div>